(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["af-blog"]) return;
  try {
    
(function(){
function updateCategories(){
document.querySelectorAll('.af-blog-page').forEach(function(section){
var title=section.querySelector('[data-af-blog-title]');
if(!title.dataset.original)title.dataset.original=title.textContent;
var category=window.location.hash.slice(1);
var labels={'reading-challenge':'Reading Challenge','short-stories':'Short Stories','book-reviews':'Book Reviews'};
var active=Object.prototype.hasOwnProperty.call(labels,category);
title.textContent=active?labels[category]:title.dataset.original;
section.querySelector('[data-af-blog-results]').hidden=active;
section.querySelector('[data-af-empty-category]').hidden=!active;
section.querySelectorAll('[data-af-category]').forEach(function(link){
if(!link.dataset.initial)link.dataset.initial=link.getAttribute('aria-current')||'none';
var selected=active?link.dataset.afCategory===category:link.dataset.initial==='page';
if(selected)link.setAttribute('aria-current','page');else link.removeAttribute('aria-current');
});
});
}
updateCategories();
window.addEventListener('hashchange',updateCategories);
document.addEventListener('shopify:section:load',updateCategories);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["af-header"]) return;
  try {
    
document.addEventListener('click',function(event){
var link=event.target.closest('.af-mobile-menu a');
if(link){var menu=link.closest('details');if(menu)menu.open=false;}
});
document.addEventListener('keydown',function(event){
if(event.key==='Escape'){document.querySelectorAll('.af-mobile-menu[open]').forEach(function(menu){menu.open=false;menu.querySelector('summary').focus();});}
});

(function(){
  let queued = false;
  function updateActiveSection(){
    queued = false;
    const header = document.querySelector('.af-header');
    if(!header) return;
    const links = Array.from(header.querySelectorAll('nav a'));
    const desktopLinks = Array.from(header.querySelectorAll('.af-desktop-nav a'));
    const path = location.pathname.replace(/\/$/, '') || '/';
    const home = new URL(header.querySelector('.af-wordmark').href).pathname.replace(/\/$/, '') || '/';
    let activeHref = null;
    let currentType = 'page';
    if(path === home){
      currentType = 'location';
      activeHref = desktopLinks[0]?.getAttribute('href');
      const marker = header.getBoundingClientRect().bottom + Math.min(160, window.innerHeight * 0.2);
      const sections = desktopLinks.map(link => {
        const hash = new URL(link.href).hash;
        const section = hash ? document.getElementById(hash.slice(1)) : null;
        return section && section.getClientRects().length ? {link,section} : null;
      }).filter(Boolean).sort((a,b) => a.section.getBoundingClientRect().top - b.section.getBoundingClientRect().top);
      sections.forEach(({link,section}) => {
        if(section.getBoundingClientRect().top <= marker) activeHref = link.getAttribute('href');
      });
      const wrapper = document.querySelector('.page-wrapper');
      const scroller = wrapper && /auto|scroll/.test(getComputedStyle(wrapper).overflowY) ? wrapper : document.scrollingElement;
      if(scroller.scrollTop > 0 && scroller.clientHeight + scroller.scrollTop >= scroller.scrollHeight - 3 && sections.length){
        activeHref = sections[sections.length - 1].link.getAttribute('href');
      }
    }else{
      const exact = desktopLinks.find(link => {
        const url = new URL(link.href);
        return !url.hash && (url.pathname.replace(/\/$/, '') || '/') === path;
      });
      activeHref = exact?.getAttribute('href') || null;
    }
    links.forEach(link => {
      const target = activeHref ? new URL(activeHref,location.href) : null;
      const url = new URL(link.href);
      if(target && url.pathname === target.pathname && url.hash === target.hash) link.setAttribute('aria-current',currentType);
      else link.removeAttribute('aria-current');
    });
  }
  function scheduleUpdate(){
    if(!queued){queued=true;requestAnimationFrame(updateActiveSection);}
  }
  document.addEventListener('scroll',scheduleUpdate,{passive:true,capture:true});
  window.addEventListener('resize',scheduleUpdate);
  window.addEventListener('hashchange',scheduleUpdate);
  window.addEventListener('load',scheduleUpdate);
  document.addEventListener('shopify:section:load',scheduleUpdate);
  document.addEventListener('shopify:section:reorder',scheduleUpdate);
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',scheduleUpdate);
  else scheduleUpdate();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
